import { createReducer, on } from '@ngrx/store';
import { setLoading, clearAllLoading } from './loading.actions';
import { LoadingState } from './loading.interface';

export const LOADING_FEATURE_KEY = 'loadingStatus';

export const initialLoadingState: LoadingState = {};

export const loadingReducer = createReducer(
    initialLoadingState,
    on(setLoading, (state, { key, loading }) => ({
        ...state,
        [key]: loading
    })),
    on(clearAllLoading, () => initialLoadingState)
);